import React from "react";
import { Link } from "react-router-dom";

import {
  FOOTER_BRAND_BAR,
  FOOTER_NAV,
  FOOTER_SOCIAL_ACTIVE,
  FOOTER_SUBSCRIBE,
} from "../../data/footerNavigation";

function FooterLink({ item, onSection, className = "nh-footer__link" }) {
  if (item.section && onSection) {
    return (
      <button type="button" className={`${className} nh-footer__link--btn`} onClick={() => onSection(item.section)}>
        {item.label}
      </button>
    );
  }
  if (item.href) {
    return (
      <a href={item.href} className={className} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    );
  }
  if (item.to) {
    return (
      <Link to={item.to} className={className}>
        {item.label}
      </Link>
    );
  }
  return <span className={className}>{item.label}</span>;
}

function SocialIcon({ type }) {
  const common = { className: "nh-footer__social-svg", viewBox: "0 0 24 24", "aria-hidden": true };
  if (type === "twitter") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        />
      </svg>
    );
  }
  if (type === "linkedin") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M20.45 20.45h-3.56v-5.59c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.69H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 110-4.12 2.06 2.06 0 010 4.12zM7.12 20.45H3.56V9h3.56v11.45z"
        />
      </svg>
    );
  }
  if (type === "facebook") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
        />
      </svg>
    );
  }
  if (type === "whatsapp") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
        />
      </svg>
    );
  }
  if (type === "soundcloud") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M1.175 12.225c-.138 0-.25.113-.25.25v3.502c0 .138.112.25.25.25h1.525v-4.002H1.175zm2.801 1.5c-.138 0-.25.112-.25.25v2.252c0 .138.112.25.25.25h1.525v-2.752H3.976zm2.801-1c-.138 0-.25.113-.25.25v3.502c0 .138.112.25.25.25h1.525v-4.002H6.777zm2.801-.75c-.138 0-.25.112-.25.25v4.252c0 .138.112.25.25.25h1.525v-4.752H9.578zm2.801-1.25c-.138 0-.25.113-.25.25v5.502c0 .138.112.25.25.25h1.525v-6.002h-1.525zm2.801-.75c-.138 0-.25.112-.25.25v6.252c0 .138.112.25.25.25h1.525V11.5H15.18zm2.801-1.25c-.138 0-.25.113-.25.25v7.502c0 .138.112.25.25.25h1.525v-8.002h-1.525zm3.551 0c-.966 0-1.75.784-1.75 1.75v4.502c0 .966.784 1.75 1.75 1.75h.225v-8.002h-.225zm3.25 1.25c-1.933 0-3.5 1.567-3.5 3.5v2.252c0 1.933 1.567 3.5 3.5 3.5h.225v-9.252h-.225z"
        />
      </svg>
    );
  }
  if (type === "youtube") {
    return (
      <svg {...common}>
        <path
          fill="currentColor"
          d="M23.5 6.2a3 3 0 00-2.11-2.12C19.59 3.5 12 3.5 12 3.5s-7.59 0-9.39.58A3 3 0 00.5 6.2 31.25 31.25 0 000 12a31.25 31.25 0 00.5 5.8 3 3 0 002.11 2.12c1.8.58 9.39.58 9.39.58s7.59 0 9.39-.58a3 3 0 002.11-2.12A31.25 31.25 0 0024 12a31.25 31.25 0 00-.5-5.8zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
        />
      </svg>
    );
  }
  return null;
}

export default function MarketingFooter({ onSectionScroll }) {
  const year = new Date().getFullYear();

  return (
    <footer className="nh-footer nh-footer--rhc">
      <div className="nh-footer__container">
        <div className="nh-footer__subscribe-row">
          <Link to={FOOTER_SUBSCRIBE.to} className="nh-footer__subscribe">
            {FOOTER_SUBSCRIBE.label}
            <span className="nh-footer__subscribe-arrow" aria-hidden>
              →
            </span>
          </Link>
        </div>

        <div className="nh-footer__rule" aria-hidden />

        <div className="nh-footer__main">
          <nav className="nh-footer__nav-vertical" aria-label="Footer">
            <ul>
              {FOOTER_NAV.map((item) => (
                <li key={item.label}>
                  <FooterLink item={item} onSection={onSectionScroll} />
                </li>
              ))}
            </ul>
          </nav>

          <div className="nh-footer__right">
            <p className="nh-footer__copyright-vertical" aria-label={`Copyright ${year} NeedHealth.Care`}>
              © NEEDHEALTH.CARE {year}
            </p>
            <ul className="nh-footer__social" aria-label="Social">
              {FOOTER_SOCIAL_ACTIVE.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="nh-footer__social-link" target="_blank" rel="noopener noreferrer">
                    <SocialIcon type={item.icon} />
                    <span className="sr-only">{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <Link to="/" className="nh-footer__mark-large" aria-label="NeedHealth.Care home">
            <span className="nh-footer__mark-large-nh">NH</span><span className="nh-footer__mark-large-c">C</span>
          </Link>
        </div>
      </div>

      <div className="nh-footer__brand-bar" role="navigation" aria-label="Platform">
        {FOOTER_BRAND_BAR.map((link) => (
          <FooterLink key={link.label} item={link} onSection={onSectionScroll} className="nh-footer__brand-bar-link" />
        ))}
      </div>
    </footer>
  );
}
